import { render, staticRenderFns } from "./ContractedWorksChanges.vue?vue&type=template&id=6bb08ba4&"
import script from "./ContractedWorksChanges.vue?vue&type=script&lang=js&"
export * from "./ContractedWorksChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports